import { FC, Fragment, useCallback, useState } from "react"
import { useFetchSubscriptionEmailLogsQuery } from "../../../../../../redux/queries"

import EngagementEmailLog from "./email-log"
import EmailViewerModal from "../../../../email-viewer-modal"
import If from "../../../../if"
import { SubscriptionDetails } from "../../../../../../types"
import { ActivityHistorySkeleton } from "../../../../skeletons"

interface Props {
  data: SubscriptionDetails
}

const EngagementEmailHistory: FC<Props> = ({ data }) => {
  const { data: emailLogs, isFetching } = useFetchSubscriptionEmailLogsQuery(
    { id: data.id },
    { skip: !data.id }
  )
  const [emailId, setEmailId] = useState<string | null>(null)

  const handleOpenEmail = (id: string) => setEmailId(id)

  const handleCloseEmail = useCallback(() => setEmailId(null), [setEmailId])

  return (
    <Fragment>
      <If
        condition={isFetching}
        then={<ActivityHistorySkeleton rows={3} className="mt-3" />}
        elseCondition={!!emailLogs && emailLogs.length !== 0}
        else={
          <div>
            {emailLogs?.map((el, idx) => (
              <EngagementEmailLog
                key={el.id}
                log={el}
                onSelect={handleOpenEmail}
                connectorVisible={idx < emailLogs.length - 1}
              />
            ))}
          </div>
        }
        default={<div>No email logs found.</div>}
      />

      <EmailViewerModal
        open={!!emailId}
        id={emailId!}
        onClose={handleCloseEmail}
      />
    </Fragment>
  )
}

export default EngagementEmailHistory
